import { Position } from '../models/position';

export class PositionHelper {

    /**
     * Calculate the relative offset of an touch/mouse event from its parent.
     *
     * @param {Event} $event
     * @param {JQuery} parentDiv
     * @returns {Position}
     */
    static calculateRelativePositionInPixel($event, parentDiv: JQuery): Position {

        const parentY = parentDiv.offset().top;
        const parentX = parentDiv.offset().left;
        const position = new Position();

        if ($event.targetTouches) {
            position.x = $event.targetTouches[0].pageX - parentX;
            position.y = $event.targetTouches[0].pageY - parentY;
        } else {
            position.x = $event.pageX - parentX;
            position.y = $event.pageY - parentY;
        }

        position.w = 0;
        position.h = 0;

        return position;
    }

    static calculateRelativePositionInPixelOfPoint(position: Position, parentDiv: JQuery): Position {

        const parentY = parentDiv.offset().top;
        const parentX = parentDiv.offset().left;
        const newPosition = new Position();

        newPosition.x = position.x - parentX;
        newPosition.y = position.y - parentY;
        newPosition.w = position.w;
        newPosition.h = position.h;

        return newPosition;
    }

    static calculateDistance(startPoint: Position, endPoint: Position): Position {

        const newStartX = Math.min(startPoint.x, endPoint.x);
        const newStartY = Math.min(startPoint.y, endPoint.y);

        const newEndX = Math.max(startPoint.x, endPoint.x);
        const newEndY = Math.max(startPoint.y, endPoint.y);

        const deltaX = newEndX - newStartX;
        const deltaY = newEndY - newStartY;

        const positionInPixel = new Position();
        positionInPixel.x = newStartX;
        positionInPixel.y = newStartY;
        positionInPixel.w = deltaX;
        positionInPixel.h = deltaY;
        positionInPixel.h = deltaY;

        return positionInPixel;
    }

    static transformPositionFromPixelToPercent(positionInPixel: Position, parentDiv: JQuery): Position {

        const parentWidthInPixel = parentDiv.width();
        const parentHeightInPixel = parentDiv.height();

        const posXInProcent = positionInPixel.x / (parentWidthInPixel / 100);
        const posYInProcent = positionInPixel.y / (parentHeightInPixel / 100);
        const deltaXinProcent = positionInPixel.w / (parentWidthInPixel / 100);
        const deltaYInProcent = positionInPixel.h / (parentHeightInPixel / 100);

        const positionInPercent = new Position();
        positionInPercent.x = posXInProcent;
        positionInPercent.y = posYInProcent;
        positionInPercent.w = deltaXinProcent;
        positionInPercent.h = deltaYInProcent;

        return positionInPercent;

    }

}
